import React from 'react'
import { get } from 'lodash'
import PaymentModal from '../../../../elements/Payment/PaymentModal'

function PaymentButton(props) {
  const { lines, amount, amountAccessor } = props

  const isAllowed = lines.filter((v) => {
    const sameCurrency = get(v, 'productLine.currency') === get(lines, '[0]productLine.currency')
    const isPositiveAmount = get(v, amountAccessor) >= 0

    // return sameCurrency && isConfirmed && isPositiveAmount
    return sameCurrency && isPositiveAmount
  })

  return (
    <PaymentModal
      {...{
        disabled: isAllowed.length !== lines.length,
        buttonTitle: 'Make Payment',
        companyID: get(lines, '[0]enquiry.company._id'),
        currency: get(lines, '[0]productLine.currency'),
        description: `Payment For Enquiry [${get(lines, '[0]enquiry.code')}]`,
        amount: amount || lines.reduce((acc, v) => acc + get(v, amountAccessor, 0), 0),
        postURL: 'stripe/enquiry',
        payload: {
          lineTitle: 'Enquires Lines',
          lines,
          columns: [
            { title: 'Name', dataIndex: 'name', key: 'name' },
            { title: 'Product', dataIndex: 'productLine.name', key: 'productLine.name' },
            { title: 'Amount', dataIndex: amountAccessor, key: amountAccessor },
          ],
        },
      }}
    />
  )
}

export default PaymentButton
